import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { mediaImg } from "../lib/images";

export const formatDate = (iso) =>
  iso ? new Date(iso).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" }) : "";

export const ArticleCard = ({ a }) => (
  <Link to={`/insights/${a.slug}`} data-testid={`article-card-${a.slug}`} className="group flex h-full flex-col overflow-hidden rounded-[20px] border border-ink/10 bg-white transition-transform duration-300 hover:-translate-y-1">
    <div className="aspect-[16/10] overflow-hidden bg-mint">
      <img {...(a.cover_image ? mediaImg(a.cover_image, "(min-width: 1024px) 30vw, (min-width: 640px) 50vw, 100vw") : { src: "/images/villa-800.webp" })} alt={a.title} width="800" height="500" loading="lazy" decoding="async" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
    </div>
    <div className="flex flex-1 flex-col p-6">
      <p className="text-xs font-semibold uppercase tracking-[0.18em] text-clay">{a.category || "Insights"} · {formatDate(a.published_at)}</p>
      <h3 className="mt-3 font-display text-xl leading-snug text-ink">{a.title}</h3>
      {a.excerpt && <p className="mt-2 line-clamp-3 text-[15px] leading-relaxed text-ink/70">{a.excerpt}</p>}
      <span className="mt-auto inline-flex items-center gap-1.5 pt-5 text-sm font-semibold text-ink">
        Read article <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
      </span>
    </div>
  </Link>
);
